import { type IPatient } from 'features/Patients/interfaces/IPatient'

export const patientsTableColumns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (_: string, record: IPatient) => (
      <>
        {record.first_name} {record.last_name}
      </>
    ),
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: 'Language',
    dataIndex: 'language',
    key: 'language',
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
]
